export const profile = {
  name: "Yaseen Al-Midani",
  firstName: "Yaseen",
  role: "Full-Stack Software Engineer",
  location: "Dubai, United Arab Emirates",
  city: "Dubai",
  timeZone: "Asia/Dubai",
  email: "yaseen.mid2000@gmail.com",
  linkedin: "https://www.linkedin.com/in/yaseen-al-midani-661123228",
  github: "https://github.com/yaseenmi",
  summary:
    "5+ years shipping React, Node.js and Odoo platforms — from pixel-perfect interfaces to Dockerized CI/CD infrastructure.",
  // [before, highlighted, after]
  bio: [
    "I'm a software engineer specializing in web application development. I have the full-stack range to own a product end to end, but my passion is building ",
    "resilient, high-performance applications",
    " that solve real business problems."
  ]
};

export const stats = [
  { value: 5, suffix: "+", label: "Years building for the web" },
  { value: 12, suffix: "+", label: "Projects delivered to production" },
  { value: 2, suffix: "", label: "Working languages — Arabic & English" }
];

export const principles = [
  {
    title: "Solve the real problem",
    text: "Solutions shaped around the client's needs, not around the tech."
  },
  {
    title: "Keep clients in the loop",
    text: "Engaged collaboration from requirements to training and handover."
  },
  {
    title: "Performance is a feature",
    text: "Resilient, fast and secure by default — measured, not assumed."
  }
];

export const services = [
  {
    title: "Frontend Engineering",
    text: "Pixel-perfect, accessible interfaces in React and Next.js — engineered for speed, SEO and conversion.",
    tags: ["React", "Next.js", "TypeScript", "Tailwind", "Three.js"]
  },
  {
    title: "Full-Stack Platforms",
    text: "End-to-end products — REST APIs, dashboards and e-commerce built on Node.js, NestJS and Laravel.",
    tags: ["Node.js", "NestJS", "Laravel", "PostgreSQL", "MongoDB"]
  },
  {
    title: "Odoo & ERP Customization",
    text: "Custom Odoo modules covering variants, workflows and permissions, with fast React front-ends layered on top.",
    tags: ["Odoo", "Python", "React", "Workflows"]
  },
  {
    title: "Secure Document Workflows",
    text: "E-signature and blockchain integrations that keep documents tamper-proof and auditable.",
    tags: ["E-Signature", "Blockchain", "Security"]
  },
  {
    title: "DevOps & Infrastructure",
    text: "Dockerized environments, CI/CD pipelines on Proxmox, Nginx, Cloudflare caching and Linux tuning.",
    tags: ["Docker", "CI/CD", "Proxmox", "Cloudflare", "Nginx"]
  }
];

export const educationHistory = [
  {
    institution: "Arab International University",
    degree: "Bachelor of Informatics Engineering",
    location: "Damascus, Syria",
    period: "Jul 2017 – Jul 2022",
    highlights: [
      "Built a strong foundation in software engineering and computer science fundamentals.",
      "Graduated with a focus on practical, industry-ready projects and collaborative teamwork."
    ]
  }
];

export const workExperience = [
  {
    company: "Borderless Security",
    role: "Full Stack Developer",
    location: "Dubai, UAE",
    period: "Feb 2024 – Present",
    current: true,
    achievements: [
      "Contributed to the development and planning of FilesDNA, the company's ERP platform for governments and enterprises.",
      "Integrated React.js with Odoo to deliver responsive, high-performance user experiences and reduced load time by 30%.",
      "Delivered custom Odoo modules covering variants, workflows, and permissions tailored to complex business requirements.",
      "Implemented E-Signature and blockchain integrations for secure, tamper-proof document workflows.",
      "Managed Dockerized environments with CI/CD pipelines on Proxmox to streamline deployment efficiency.",
      "Optimized performance through Cloudflare caching, Linux tuning, and Google Cloud Storage integrations."
    ]
  },
  {
    company: "Pancode",
    role: "Frontend Developer",
    location: "Damascus, Syria",
    period: "Dec 2022 – Sep 2023",
    achievements: [
      "Built and maintained user-facing features with React.js, Redux, and Chakra UI to meet aggressive delivery timelines.",
      "Improved UX through responsive design and performance optimization that boosted engagement.",
      "Partnered with cross-functional stakeholders to align design and backend efforts with product objectives."
    ]
  },
  {
    company: "Freelance",
    role: "Full Stack Developer",
    location: "Remote",
    period: "Dec 2021 – Present",
    current: true,
    achievements: [
      "Developed responsive web applications and dashboards with React, Node.js, and Laravel.",
      "Delivered SEO-optimized solutions that balanced high performance with strong security practices.",
      "Collaborated closely with clients to gather requirements, provide documentation, and deliver training."
    ]
  }
];

export const skillCategories = [
  {
    id: "frontend",
    label: "Frontend",
    skills: [
      "React.js",
      "Next.js",
      "TypeScript",
      "Redux",
      "Three.js",
      "Tailwind",
      "Chakra UI",
      "Material UI",
      "Sass",
      "Bootstrap",
      "HTML",
      "CSS",
      "SEO Optimization"
    ]
  },
  {
    id: "backend",
    label: "Backend",
    skills: ["Node.js", "Express", "NestJS", "PHP", "Laravel", "Odoo (Python)", "RESTful APIs"]
  },
  {
    id: "database",
    label: "Database",
    skills: ["PostgreSQL", "MySQL", "MongoDB"]
  },
  {
    id: "devops",
    label: "DevOps & Infrastructure",
    skills: [
      "Docker",
      "CI/CD Pipelines",
      "Proxmox",
      "Linux (Ubuntu, Debian)",
      "Nginx",
      "Cloudflare",
      "Google Cloud Storage"
    ]
  },
  {
    id: "tools",
    label: "Tools",
    skills: ["Git", "Chrome Extensions"]
  },
  {
    id: "soft-skills",
    label: "Soft Skills",
    skills: ["Problem Solving", "Team Collaboration", "Time Management", "Communication"]
  },
  {
    id: "languages",
    label: "Languages",
    skills: ["Arabic (Native)", "English (Fluent)"]
  }
];

export const marqueeItems = [
  "React",
  "Next.js",
  "TypeScript",
  "Node.js",
  "NestJS",
  "Laravel",
  "Odoo",
  "PostgreSQL",
  "MongoDB",
  "Docker",
  "CI/CD",
  "Cloudflare",
  "Three.js",
  "Tailwind"
];
